import { hasRole } from "@lawline/shared/access/platform";

import { authClient } from "@platform/auth/client";
import { sessionMutationOptions } from "@platform/auth/session-transition.context";
import { useAuth } from "@platform/auth/context";
import { TenantExitAction } from "./tenant-exit-action";

// Hidden for the owner, who must transfer ownership first (the server also
// rejects the only owner).
export function LeaveTenant({ className }: { className?: string }) {
	const { role } = useAuth();

	return (
		<TenantExitAction
			namespace="tenant.leave"
			hidden={hasRole(role ?? "", "owner")}
			run={(organizationId) =>
				authClient.organization.leave({ organizationId, fetchOptions: sessionMutationOptions })
			}
			className={className}
		/>
	);
}
